<template>
  <div
    class="
      resultStatus
      resultCompleted
      full-width
      full-height
      flex column
      justify-center
      text-center
      q-px-lg
    "
  >
    <div
      v-if="
        serviceTypeStatus === 'DELIVERY' &&
          [
            200,
            300,
            400,
            500,
            600,
            610,
            620,
            630,
            700,
            800,
            900,
            1000,
            1010,
            1020,
            1030,
            1040,
            1080
          ].includes(shipmentStatusCode)
      "
    >
      <div class="title font-size-20 text-weight-bolder statuscode-box">
        <div>
          <strong v-html="orderMsgs.status" />
        </div>
        <div>
          <strong> {{ orderMsgs.Driver }}</strong>
        </div>
        <div>
          <strong> {{ orderMsgs.Seller }}</strong>
        </div>
      </div>
      <div class="YourMeal-box">
        <div
          v-if="
            serviceTypeStatus === 'DELIVERY' &&
              [
                200,
                300,
                400,
                500,
                600,
                610,
                620,
                630,
                700,
                800,
                900,
                1000,
                1010,
                1020,
                1030,
                1040,
                1080
              ].includes(shipmentStatusCode)
          "
          class="desc font-size-16 text-theme-gray q-my-sm statuscode-value "
        >
          <span> {{ orderMsgs.value }}</span>
        </div>
        <div
          v-if="[900].includes(shipmentStatusCode)"
          class="desc font-size-16 text-theme-gray q-my-sm CourierInfo "
        >
          <span> {{ orderMsgs.CourierInfo }}</span>
        </div>
        <div
          v-if="[700, 800].includes(shipmentStatusCode)"
          class="desc font-size-16 text-theme-gray q-my-sm CourierInfo"
        >
          <span> {{ orderMsgs.CourierInfo }}</span>
        </div>
        <div
          v-if="[700, 800].includes(shipmentStatusCode)"
          class="desc text-theme-gray q-my-sm GKNumber"
        >
          <span> {{ shipmentExternalId }}</span>
        </div>
      </div>

      <div class="CheckDetails">
        <span @click="alterCheck">{{ $t('result.showDetilStatus1') }}</span>
        <!-- <q-img
          src="~assets/icons/svg/icon/ChevronRight.svg"
          style="width: 16px;height: 20px;"
        /> -->
        <span class="iconfont">&#xe744;</span>
      </div>
    </div>

    <div v-if="serviceTypeStatus !== 'DELIVERY'">
      <div class="title font-size-24 text-weight-bolder">
        {{
          detail.serviceType === 'DINE_IN'
            ? $t('result.completedTitle1')
            : $t('result.completedTitle2')
        }}
      </div>
      <div class="desc font-size-12 text-theme-gray q-my-sm">
        {{
          detail.serviceType === 'DINE_IN'
            ? $t('result.completedDesc1', [table])
            : $t('result.completedDesc2')
        }}
      </div>
    </div>
    <Popup :service-type="serviceTypeStatus" @setPopupChild="setPopupChild" />
  </div>
</template>

<script>
import orderMixins from 'pages/mixin/orderMixins.js';
import { getStoreInfo } from 'src/api/home.js';
// import { sellerTracking } from 'src/api/order.js';
import Popup from './Popup.vue';

export default {
  components: {
    Popup,
  },
  mixins: [orderMixins],
  props: {
    mealCode: {
      type: String,
      default: '',
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      showTypeInit: false,
      code: this.mealCode,
      table: '',
      serviceTypeStatus: '',
      shipmentStatusCode: '',
      paymentMethodType: '',
      shipmentExternalId: ''
    };
  },
  watch: {
    detail: {
      handler(val) {
        val = val || {};
        this.serviceTypeStatus = val.serviceType;
        if (val.shipment) {
          this.shipmentStatusCode = val.shipment.trackingStatusCode;
          this.paymentMethodType = val.payments[0].paymentMethodType;
          this.shipmentExternalId = val.shipment.externalId;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 历史记录 插入当前界面
      window.history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
    // table 字段修改
    getStoreInfo().then(res => {
      this.table = this.$t(`list.table${this.storeInfo.businessType}`);
    });
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    setPopupChild(child) {
      this.popupChild = child;
    },
    alterCheck() {
      if (this.popupChild) {
        this.popupChild.alert = true;
      }
    },
    getStatus(code) {
      code = +code;
      //  * 等待支付
      // WAITING_TO_PAID(200),
      if (code >= 200 && code < 300) {
        return 200;
      }
      //  * 付款成功
      // PAID(300),
      if (code >= 300 && code < 400) {
        return 300;
      }
      //  * 商家已接单
      // ACCEPTED(400),
      if (code >= 400 && code < 500) {
        return 400;
      }
      //  * 商家备餐中
      // PREPARING(500),
      if (code >= 500 && code < 600) {
        return 500;
      }
      //* 等待骑手到店取货
      // READY(600)
      if (code >= 600 && code < 610) {
        return 600;
      }
      // Searching for Courier 寻找棋手
      if (code >= 610 && code < 620) {
        return 610;
      }
      //   Driver Assigned  找到棋手
      if (code >= 620 && code < 630) {
        return 620;
      }
      /// / On the Way Pick Up  棋手正在来的路上
      if (code >= 630 && code < 700) {
        return 630;
      }
      //  * 骑手到店已取货
      // PICKED_UP(700),
      if (code >= 700 && code < 800) {
        return 700;
      }
      //  * 配送中
      // DELIVERING(800)  //Delivering to customer  棋手正在 送货
      if (code >= 800 && code < 900) {
        return 800;
      }
      //  * 已送达
      // DELIVERED(900),       // Delivered   交付完成
      if (code >= 900 && code < 1000) {
        return 900;
      }
      if (code >= 1000 && code <= 1030) {
        return 610;
      }
      /// // 订单失败状态
      if (code > 1030 && code < 1040) {
        return 1040;
      }
      return '';
    },
    goBack() {
      window.history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style lang="scss" scoped>

.resultCompleted {
  background: url('~src/assets/images/result/completedBg.png') no-repeat center;
  background-size: cover;
  .title {
    line-height: 120%;
    margin-top: 180px !important;
  }
  .desc {
    line-height: 16px;
  }
}
//////
.YourMeal {
  color: #6b7280;
  font-weight: normal;
}
.Thank-courier > div {
  color: #6b7280;
  font-weight: normal;
}
.CheckDetails {
  margin-top: 10px;
  font-weight: bold;
  color: $primary;
  font-size: 12px;
  .iconfont{
    vertical-align: middle;
  }
}

// .deiver-box>div{
//   color: #fff;
// }
.statuscode-box {
  color: #ff9e2d;
}
.statuscode-value {
  color: #6b7280;
}

.CourierInfo {
  color: $black;
}
.GKNumber {
  font-size: 36px;
  color: $black;
  font-weight: bold;
}
</style>
